import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=a4c2c066"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4c2c066')) {
      api.createRecord('a4c2c066', component.options)
    } else {
      api.reload('a4c2c066', component.options)
    }
    module.hot.accept("./ProfileIcon.vue?vue&type=template&id=a4c2c066", function () {
      api.rerender('a4c2c066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ProfileIcon.vue"
export default component.exports